import { render } from "./EvaluationResultListReport.vue?vue&type=template&id=163f22aa&scoped=true"
import script from "./EvaluationResultListReport.vue?vue&type=script&lang=js"
export * from "./EvaluationResultListReport.vue?vue&type=script&lang=js"

import "./EvaluationResultListReport.vue?vue&type=style&index=0&id=163f22aa&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163f22aa"]])

export default __exports__